__turbopack_context__.v({
  "iframe": "vSj56G_iframe",
  "media": "vSj56G_media",
  "playIcon": "vSj56G_playIcon",
  "playThumb": "vSj56G_playThumb",
});
